import * as React from 'react'
import type { SVGProps } from 'react'
const SvgChevronDown = (
  props: SVGProps<SVGSVGElement> & { color?: string },
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.707 7.293a1 1 0 0 0-1.414 1.414l8 8a1 1 0 0 0 1.414 0l8-8a1 1 0 1 0-1.414-1.414L12 14.586z"
    />
  </svg>
)
export default SvgChevronDown
